import React, { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";
import { BsPencil } from "react-icons/bs";

const NewProfileModal = ({ isOpen, onClose, isAbout, onSave }) => {
  const [selectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    if (isOpen) {
      setSelectedStatus(isAbout || "Love my self");
    }
  }, [isOpen, isAbout]);

  const statuses = [
    "Love my self",
    "Busy",
    "Available",
    "At office",
    "In a meeting",
    "Working remotely",
    "On a break",
    "Out of the office",
    "Traveling for business",
    "In a training session",
    "On vacation",
    "Sick leave",
    "Pending response",
    "In a conference",
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-1000 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white w-full max-w-xl p-6 rounded-lg relative shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-4 right-3 text-gray-500 hover:text-black"
        >
          <MdClose size={24} />
        </button>

        <h2 className="text-xl font-semibold mb-4">About</h2>

        <label className="block text-md font-normal text-gray-700 mb-2 mt-6">
          Change this to
        </label>
        <div className="relative mb-6">
          <input
            type="text"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            maxLength={60}
            className="w-full border border-gray-300 rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]"
          />
          <BsPencil className="absolute right-3 top-3 transform text-black" />
        </div>

        <label className="block text-md font-normal text-gray-700 my-4">
          Select about
        </label>
        <div className="space-y-5 max-h-96 overflow-y-auto pr-2">
          {statuses.map((status) => (
            <label key={status} className="flex items-center space-x-2">
              <input
                type="radio"
                name="about"
                value={status}
                checked={selectedStatus === status}
                onChange={() => setSelectedStatus(status)}
                className="accent-[var(--primary-color)]"
              />
              <span>{status}</span>
            </label>
          ))}
        </div>

        <button
          onClick={() => {
            onSave(selectedStatus);
            onClose();
          }}
          className="btn btn-primary bg-[var(--primary-color)] w-fit mt-5 px-10 text-white rounded-full ml-auto block"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default NewProfileModal;
